import { Navigate, useNavigate } from 'react-router-dom';
import { useSession } from '../lib/session';

/**
 * "Report it", from the sidebar, without having to find the company first.
 *
 * The raise-a-request form has always needed a company in the URL, so the only way in was via
 * the company page — which means knowing which company your problem belongs to before you can
 * report it. Most people belong to one, so this works it out and goes straight there; anybody
 * in several is asked, once, and lands on the same form.
 *
 * It redirects rather than rendering the form itself, so there is one implementation of
 * raising a request and the URL somebody ends up on is still one they can send to a colleague.
 */
export function ReportRoute() {
  const { session } = useSession();
  const navigate = useNavigate();
  const companies = session?.companies ?? [];

  if (companies.length === 1) {
    return <Navigate to={`/companies/${companies[0].id}/request`} replace />;
  }

  if (companies.length === 0) {
    return (
      <div className="page-head">
        <div>
          <div className="eyebrow">Service</div>
          <h1>Report it</h1>
          <p className="subtitle">
            You are not a member of any company yet, so there is nothing to report against. An
            administrator adds you to one.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-head">
        <div>
          <div className="eyebrow">Service</div>
          <h1>Report it</h1>
          <p className="subtitle">
            Something broken, or something you need from us. Which company is it about?
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-pad stack-sm">
          {companies.map((company) => (
            <button
              key={company.id}
              type="button"
              className="btn"
              style={{ justifyContent: 'flex-start' }}
              onClick={() => navigate(`/companies/${company.id}/request`)}
            >
              {company.name}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
